import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Seo } from '@/components/Seo';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-softWhite">
      <Seo title="Siden finnes ikke | Kommunale avgifter" noindex />
      <Header />
      
      <main className="flex-grow flex items-center justify-center">
        <div className="text-center p-8">
          <h1 className="text-6xl font-bold text-nordicBlue mb-4">404</h1>
          <p className="text-2xl text-deepCharcoal mb-6">Beklager, siden finnes ikke</p>
          <p className="text-warmGray mb-8">Vi kunne ikke finne siden du lette etter.</p>
          
          <Button 
            className="flex items-center gap-2" 
            onClick={() => navigate('/')}
          >
            <Home className="h-4 w-4" />
            <span>Gå til forsiden</span>
          </Button>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
